import { remove } from './client'
import type { BackendMeta } from './types'

export type RemoveCaseFile = BackendMeta<
  '/api/workspaces/{workspace_id}/cases/{case_id}/files/{file_id}',
  'delete'
>
/**
 * Remove a file from a case.
 * Only files in "errored" or "uploading" state can be removed.
 * There is an ongoing discussion whether we should allow this for all,
 * or at least all orphaned files.
 */
export const removeCaseFile = (workspaceId: string, caseId: string, fileId: string) =>
  remove<RemoveCaseFile['body'], RemoveCaseFile['successResponse'], RemoveCaseFile['path']>(
    `/api/workspaces/${workspaceId}/cases/${caseId}/files/${fileId}`,
    undefined,
  )
